import React, { Suspense, useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import App from './App';
import PageNotFound from './components/shared/PageNotFound/PageNotFound';
import OnboardingRoute from './components/Onboarding/Onboarding.route';
import TestReportRoute from './components/TestReport/TestReport.route';
import Loader from './components/Loader/Loader';
import { addFaviconInDOM, getTestSlugFromPath } from './utils/whitelabel.utils';
import { retry } from './utils/utils';
import { getWLCompanyData } from './actions/whitelabel.action';

const OnboardingContainer = React.lazy(() =>
  retry(() => import('./containers/onboarding/OnboardingContainer'))
);

const TestReportContainer = React.lazy(() =>
  retry(() => import('./containers/testReport/TestReportContainer'))
);

const MultiTabPage = React.lazy(() =>
  retry(() => import('./pages/MultTab/MultiTab'))
);

const Playground = React.lazy(() =>
  retry(() => import('./components/Playground'))
);

const PodMultiSession = React.lazy(() =>
  retry(() =>
    import('./components/ProblemTypes/PodBasedSolution/PodMultiSession')
  )
);

const Routes = () => {
  const dispatch = useDispatch();
  const { wlCompanyAPICompleted, faviconUrl } = useSelector(
    state => ({
      wlCompanyAPICompleted: state.whitelabelCompanyData.wlCompanyAPICompleted,
      faviconUrl: state.whitelabelCompanyData.faviconUrl,
    }),
    shallowEqual
  );

  useEffect(() => {
    if (!wlCompanyAPICompleted && !faviconUrl) {
      dispatch(getWLCompanyData(getTestSlugFromPath()));
    }
    if (faviconUrl) {
      addFaviconInDOM(faviconUrl);
    }
  }, [wlCompanyAPICompleted, faviconUrl]);

  return (
    <Switch>
      <OnboardingRoute path="/:testslug/onboarding">
        <OnboardingContainer />
      </OnboardingRoute>
      <TestReportRoute exact path="/test-report/:testslug">
        <TestReportContainer />
      </TestReportRoute>
      <Route path="/test/:testslug">
        <App />
      </Route>
      <Route exact path="/multi-session">
        <MultiTabPage />
      </Route>
      <Route
        exact
        path="/library/problem/:problemslug/edit/:editingfolder/pod-multi-session"
      >
        <Suspense fallback={<Loader />}>
          <PodMultiSession />
        </Suspense>
      </Route>
      <Route
        exact
        path={[
          '/library/problem/:problemslug/trial',
          '/test-report/problem/:problemslug/solution-review/:solutionslug',
          '/library/problem/:problemslug/edit/:editingfolder',
          '/creator/problem/:problemslug/trial',
        ]}
      >
        <Suspense fallback={<Loader />}>
          <Playground />
        </Suspense>
      </Route>
      <Route>
        <PageNotFound />
      </Route>
    </Switch>
  );
};

export default Routes;
